import { render, staticRenderFns } from "./NewTenderStageBtn.vue?vue&type=template&id=34a84fc6&scoped=true"
import script from "./NewTenderStageBtn.vue?vue&type=script&lang=js"
export * from "./NewTenderStageBtn.vue?vue&type=script&lang=js"
import style0 from "./NewTenderStageBtn.vue?vue&type=style&index=0&id=34a84fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a84fc6",
  null
  
)

export default component.exports